import React, { useState, useEffect, useRef } from "react";

export const LanguageDropdown = ({ languages, defaultLang, onLanguageChange }) => {
  const [selectedLang, setSelectedLang] = useState(defaultLang);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Handle language change
  const handleSelect = (langCode) => {
    setSelectedLang(langCode);
    setIsOpen(false);
    onLanguageChange(langCode);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const selectedOption = languages.find((lang) => lang.code === selectedLang);

  return (
    <div ref={dropdownRef} className="language-dropdown" style={{ position: "relative", width: "220px" }}>
      {/* Dropdown Button */}
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#fff",
          padding: "10px",
          borderRadius: "8px",
          cursor: "pointer",
          border: "1px solid #ccc",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img src={selectedOption.flag} alt={selectedOption.label} width="24" />
          <span>{selectedOption.label}</span>
        </div>
        <span style={{ fontSize: "18px" }}>{isOpen ? "▲" : "▼"}</span>
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "110%",
            left: 0,
            width: "100%",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "8px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
            zIndex: 10,
          }}
        >
          {languages.map((lang) => (
            <div
              key={lang.code}
              onClick={() => handleSelect(lang.code)}
              style={{
                padding: "10px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                cursor: "pointer",
                backgroundColor:
                  selectedLang === lang.code ? "#f5f5f5" : "transparent",
                fontWeight: selectedLang === lang.code ? "bold" : "normal",
              }}
            >
              <img src={lang.flag} alt={lang.label} width="24" />
              <span>{lang.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};